export const WORKSPACE_PANELS = [
  { id: "preview", label: "Preview", icon: "fas fa-file-alt" },
  {
    id: "libraryStaff",
    label: "Document Library Staff",
    icon: "fas fa-users",
  },
  {
    id: "learningStaff",
    label: "My Learning Staff",
    icon: "fas fa-user-graduate",
  },
  {
    id: "learningProgress",
    label: "Learning progress",
    icon: "fas fa-chart-pie",
  },
  {
    id: "associatedDocs",
    label: "Associated Documents",
    icon: "fas fa-link",
  },
  { id: "reviewers", label: "Reviewers", icon: "fas fa-user-check" },
  { id: "approvers", label: "Approvers", icon: "fas fa-user-shield" },
  {
    id: "auditLog",
    label: "Audit Log",
    icon: "fas fa-clipboard-list",
  },
  { id: "quiz", label: "Quiz", icon: "fas fa-question-circle" },
  {
    id: "olderVersion",
    label: "Older Version",
    icon: "fas fa-history",
  },
];

export const WORKSPACE_VAULT_PANELS = new Set([
  "associatedDocs",
  "reviewers",
  "approvers",
  "auditLog",
  "quiz",
  "olderVersion",
]);

/** Read-only workspace tabs for Document Control (no staff / learning edit panels). */
export const DOCUMENT_CONTROL_READONLY_PANELS = WORKSPACE_PANELS.filter(
  (panel) => !["libraryStaff", "learningStaff", "learningProgress"].includes(panel.id),
);
